<template>
  <div
    class="d-flex range-wrap"
    :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
  >
    <!-- SELECT RANGE -->
    <div class="flex-grow-1 px-2 pb-3">
      <v-select
        v-model="select"
        :items="items"
        item-text="label"
        item-value="value"
        :label="$t('breaks')"
        hide-details
        solo-inverted
        return-object
        prepend-icon="mdi-calendar-range"
        :disabled="disabledRangeSelect"
      ></v-select>
    </div>

    <!-- RANGE MENU - 1 - DATA_INÍCIO -->
    <div class="d-flex flex-grow-1 px-2 pb-3">
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :nudge-right="40"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="dateStartBr"
            label=""
            prepend-icon="mdi-calendar-today  "
            :prefix="$t('from')"
            readonly
            solo-inverted
            hide-details
            :disabled="disabledRange"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date_start"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
      <v-text-field
        v-model="time_inicio"
        :disabled="disabledRange"
        label="hh:mm:ss"
        solo-inverted
        class="ml-2"
        :hide-details="hideDetails"
        :error="!hideDetails"
        :error-messages="errorTime"
        v-mask="'##:##:##'"
      >
      </v-text-field>
    </div>

    <!-- RANGE MENU - 2 - date_final -->
    <div class="d-flex flex-grow-1 px-2 pb-3">
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :nudge-right="40"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="dateEndBr"
            label=""
            prepend-icon="mdi-calendar"
            :prefix="$t('until')"
            readonly
            solo-inverted
            hide-details
            :disabled="disabledRange"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date_final"
          @input="fromMenu = false"
        ></v-date-picker>
      </v-menu>
      <v-text-field
        v-model="time_final"
        :disabled="disabledRange"
        label="hh:mm:ss"
        solo-inverted
        class="ml-2"
        :hide-details="hideDetails"
        :error="!hideDetails"
        :error-messages="errorTime"
        v-mask="'##:##:##'"
      >
      </v-text-field>
    </div>
  </div>
</template>
<script>
export default {
  name: "components-common-range-rangedate",
  data: () => ({
    date_start_br: "",
    date_final_br: "",
    limitRangeDate: {
      min: "",
      max: "",
    },
    items: [],
    // SELECT:
    select: {
      label: "Hoje",
      value: "today",
    },

    // CALENDAR MENU RANGE:
    date_start: "",
    date_final: "",
    menu1: false,
    menu2: false,
    disabledRangeSelect: false,
    time_inicio: "",
    time_final: "",
    errorTime: "",
    hideDetails: true,
  }),
  mounted() {
    this.weeklyDealHandle();
    const selectRangeDays = {
      7: this.itemsWeek,
      15: [...this.itemsWeek, ...this.itemsHalfMonth],
      31: [...this.itemsWeek, ...this.itemsHalfMonth, ...this.itemsMonth],
    };
    this.items =
      selectRangeDays[this.$route.meta.filterLimitDays] || selectRangeDays[7];
    this.select = this.selectHandle();
    // console.log(this.items);
    // this.select = this.selectTranslate;
  },
  computed: {
    itemsWeek() {
      return [
        {
          label: this.$t("todayLable"),
          value: "today",
        },
        {
          label: this.$t("yesterdayLable"),
          value: "yesterday",
        },
        {
          label: this.$t("lastSevenDaysLable"),
          value: "lastSevenDays",
        },
        {
          label: this.$t("currentWeekLable"),
          value: "currentWeek",
        },
        {
          label: this.$t("lastWeekLable"),
          value: "lastWeek",
        },
      ];
    },
    itemsHalfMonth() {
      return [
        {
          label: this.$t("lastFifteenDaysLable"),
          value: "halfMonth",
        },
      ];
    },
    itemsMonth() {
      return [
        {
          label: this.$t("currentMonthLable"),
          value: "currentMonth",
        },
        {
          label: this.$t("lasttMonthLable"),
          value: "lastMonth",
        },
      ];
    },
    // Recuperando o Range armazenado no Store.
    rangeDate() {
      // console.log("Computed: rangeDate");
      return this.$store.state.rangeGlobal.date;
    },
    dateStartBr() {
      // console.log("Computed: dateStartBr");
      return this.$store.state.rangeGlobal.date_start_br;
    },
    dateEndBr() {
      // console.log("Computed: dateEndBr");
      return this.$store.state.rangeGlobal.date_end_br;
    },
    timeStart() {
      // console.log("Computed: timeStart");
      return this.$store.state.rangeGlobal.time_start;
    },
    timeEnd() {
      // console.log("Computed: timeEnd");
      return this.$store.state.rangeGlobal.time_end;
    },
    disabledRange() {
      // console.log("Computed: disabledRange");
      return this.$store.state.rangeGlobal.disabled;
    },
    // Recuperando o Select
    selectDate() {
      // console.log("Computed: selectDate");
      return this.$store.state.rangeGlobal.select;
    },
  },
  watch: {
    rangeDate(val) {
      // console.log("watch rangeDate");
      // console.log(val);
      val && this.buildRangeUI();
    },

    // Se os dois menus estiverem preenchido
    // pode setar no store o range.
    date_start(val) {
      // console.log("watch date_start");
      // console.log(val);
      if (val && this.date_final != "") {
        this.setRangeStore();
      }
    },

    // Se os dois menus estiverem preenchido
    // pode setar no store o range.
    date_final(val) {
      // console.log("watch date_final");
      // console.log(val);
      if (val && this.date_start != "") {
        this.setRangeStore();
      }
    },

    time_inicio(val) {
      // console.log("watch time_inicio");
      // console.log(val);
      // if (!val) return;
      if (val.length == 8) {
        this.timeValidated(val);
      }
    },

    time_final(val) {
      // console.log("watch time_final");
      // console.log(val);
      // if (!val) return;
      if (val.length == 8) {
        this.timeValidated(val);
      }
    },

    timeStart(val) {
      // console.log("watch timeStart");
      // console.log(val);
      this.time_inicio = val;
    },

    timeEnd(val) {
      // console.log("watch timeEnd");
      // console.log(val);
      this.time_final = val;
    },

    // Mantendo o Select Sincronizado com os menus date picker
    async select(select) {
      // console.log("watch select");
      // console.log(select);
      if (select == null) return;
      // console.log("watch select - 2");

      this.$store.commit("setDisabledRange", false);
      this.$store.commit("SetRangeGlobalSelect", select);

      var rangeDate;
      // if (select.value === "weekly_deal") {
      //   // console.log(select)
      //   this.$store.commit("setDisabledRange", true);
      //   rangeDate = await this.$date.get[select.value]();
      //   this.$store.commit("SetRangeGlobalDate", rangeDate);
      //   return;
      // }

      // Escopo if acima substituido pelo escopo abaixo, para incluir
      // "Apuração Atual" de maneira que não fosse preciso copiar código
      // e reaproveitar parte do código já existente.

      var deals = [
        {
          text: "weekly_deal",
          value: 1,
        },
        {
          text: "current_deal",
          value: 2,
        },
      ];
      let deal = deals.find((item) => {
        return item.text == select.value;
      });

      if (deal) {
        this.$store.commit("setDisabledRange", true);
        rangeDate = await this.$date.get["allDeals"](deal.value);
        this.$store.commit("SetRangeGlobalDate", rangeDate);
        return;
      }

      // // Reset
      // this.$store.commit("SetRangeGlobalDate", {
      //   date_start: "",
      //   date_final: "",
      // });
      this.$store.commit("SetTimeStart", "");
      this.$store.commit("SetTimeEnd", "");
      this.date_final = "";
      this.date_start = "";
      // this.time_inicio = "";
      // this.time_final = "";

      // Get Range
      rangeDate = await this.$date.get[select.value]();

      // Date
      this.date_start = rangeDate.date_start.slice(0, -13);
      this.date_final = rangeDate.date_final.slice(0, -13);

      // Configuration to toLocaleTimeString
      // Time all return 00:00:00 or 23:59:59
      let options = {
        second: "2-digit",
        minute: "2-digit",
        hour: "2-digit",
        hourCycle: "h23",
      };
      this.time_inicio = new Date(rangeDate.date_start).toLocaleTimeString(
        navigator.language,
        options
      );
      this.time_final = new Date(rangeDate.date_final).toLocaleTimeString(
        navigator.language,
        options
      );
    },

    // SETUP change route:
    $route() {
      this.weeklyDealHandle();

      // this.select = this.selectDate;
      const selectRangeDays = {
        7: this.itemsWeek,
        15: [...this.itemsWeek, ...this.itemsHalfMonth],
        31: [...this.itemsWeek, ...this.itemsHalfMonth, ...this.itemsMonth],
      };
      this.items =
        selectRangeDays[this.$route.meta.filterLimitDays] || selectRangeDays[7];
      this.select = this.selectHandle();

      // **************** DEPRECTADED ******************
      // this.disabledRangeSelect =
      //   this.$route.name == "AdministratorBetList" && this.selectResultBet == 0
      //     ? true
      //     : false;
    },
  },
  methods: {
    timeValidated(time) {
      // console.log("method: timeValidated");

      if (time > "23:59:59") {
        this.errorTime = this.$t("invalidTime");
        this.hideDetails = false;
        this.$store.commit("DisabledSave", true);
        return;
      }

      this.$store.commit("DisabledSave", false);
      this.errorTime = "";
      this.hideDetails = true;

      // Quando Selecionado "Apuração Semanal"
      // Não executar a validação de Time
      // Porque ele já vem do banco de dados correto.
      // E evita erro na UI principalmente
      // quando executa this.setRangeStore() dentro
      // desse escopo.
      if (this.rangeDate.weekly_deal || this.rangeDate.current_deal) return;
      this.setRangeStore();
    },

    weeklyDealHandle() {
      const retail = localStorage.getItem("operator-retail");
      // Remove Apuração Semanal, Apuração Atual para o retail 0 e 1.
      if (retail != 2) return;
      // console.log("method: weeklyDealHandle");
      const routeName = this.$route.name;
      const supportedPages = [
        "AdministratorFinancialSalesReport",
        "RegionalManagerFinancialApuration",
        "LocalManagerFinancialApuration",
        "LocalManagerFinancialApurationAgent",
      ];
      if (supportedPages.includes(routeName)) {
        const weeklyDeal = {
          label: this.$t("weeklyCalculation"),
          value: "weekly_deal",
        };
        const currentDeal = {
          label: this.$t("currentCalculation"),
          value: "current_deal",
        };
        this.itemsWeek.splice(1, 0, weeklyDeal, currentDeal);
      } else if (
        this.itemsWeek.some(
          (item) => item.value === "weekly_deal" && "current_deal"
        )
      ) {
        this.itemsWeek.splice(1, 2);
      }
    },

    // Set limit range
    setLimitRange() {
      // console.log("method: setLimitRange");
      // Set limit range

      // let gmtHour = 23 + Number(this.$gmtShort());
      let max;
      max = new Date(
        new Date(this.date_start).setHours(this.$gmtHour(), 59, 59)
      )
        .add(this.$route.meta.filterLimitDays || 7)
        .toISOString();

      this.limitRangeDate = { min: this.date_start, max };
    },

    // Set Menu Range for Store
    setRangeStore() {
      // console.log("method: setRangeStore");
      // Limite o Range com base na seleção
      this.setLimitRange();

      // Tratamento Data: Inicio e Final
      // var date_start = new Date(this.date_start).toISOString().slice(0, -1);
      // var date_final = new Date(new Date(this.date_final).setHours(20, 59, 59))
      //   .add(1)
      //   .toISOString()
      //   .slice(0, -1);

      var date_start = `${this.date_start}T${this.time_inicio}.000`;
      var date_final = `${this.date_final}T${this.time_final}.000`;

      // Se os dois campos tiverem preenchidos armazenar no Store.
      if (date_start != "" && date_final != "") {
        this.$store.commit("SetRangeGlobalDate", { date_start, date_final });
      }
    },

    // Select Handle
    // Mantendo o select Padronizado com
    // a troca de route
    selectHandle() {
      // console.log("method selectHandle");
      if (
        this.items.some((element) => element.value === this.selectDate.value)
      ) {
        return this.selectDate;
      } else {
        return this.itemsWeek[3];
      }
    },

    // Construindo o Range na UI
    buildRangeUI() {
      // console.log("method: buildRangeUI - 1");
      // Tratamento quando o usuário seleciona;
      // 'weekly_deal' (Apuração semanal);
      if (this.rangeDate.weekly_deal) {
        const week =
          this.rangeDate.weekly_deal == 1
            ? this.$date.get["lastWeek"]()
            : this.$date.get["currentWeek"]();

        let dt_start = new Date(week.date_start).toLocaleDateString();
        let dt_end = new Date(week.date_final);
        Date.prototype.addHours = function(value) {
          this.setHours(this.getHours() + value);
        };
        dt_end.addHours(1);
        dt_end = new Date(dt_end).toISOString();
        dt_end = new Date(dt_end).toLocaleDateString();
        this.$store.commit("SetDateStartBr", dt_start);
        this.$store.commit("SetDateEndBr", dt_end);
        this.time_inicio = "";
        this.time_final = "";
        return;
      }

      // console.log("method: buildRangeUI - 3");

      // Handle
      var rangeDate = this.rangeDate;
      let dt_start = new Date(rangeDate.date_start).toLocaleDateString();
      let dt_end = new Date(rangeDate.date_final).toLocaleDateString();

      // Preenche os Campos "De:" e "Até" na interface;
      this.$store.commit("SetDateStartBr", dt_start);
      this.$store.commit("SetDateEndBr", dt_end);
      // Range UI - Normalmente é recuperado nas views para Impressão.
      // Mas pode ter outras utilizadades de exibição nas páginas;
      let rangeUi = `${this.$t("from")} ${dt_start} ${
        this.time_inicio
      } ${this.$t("until")} ${dt_end} ${this.time_final}`;
      this.$store.commit("setRangeGlobalUI", rangeUi);
    },
  },
};
</script>
<style scoped>
.range-wrap {
  flex-wrap: wrap;
}
.range-wrap > div {
  flex-basis: 33.3333333333%;
}
</style>
